import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useLookupCustomers = () =>
  useMutation({
    mutationFn: () => client("lookups/customers"),
  });
export const useLookupServicePoints = () =>
  useMutation({
    mutationFn: (customerId) =>
      client(`lookups/customer/cit/sites/${customerId}`),
  });
export const useLookupMachinesServicePoints = () =>
  useMutation({
    mutationFn: (customerId) =>
      client(`lookups/customer/machine/sites/${customerId}`),
  });
export const useLookupAllMachinesServicePoints = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (customerId) =>
      client(`lookups/customer/machine/sites/all/${customerId}`),
    onSuccess: (data, customerId) => {
      // Manually write to the query cache
      queryClient.setQueryData(["locations", customerId], data);
    },
  });
};

export const useLookupActivityTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/activity/types`),
  });

export const useLookupServiceTicketActivityTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/activity/types/service/tickets`),
  });

export const useLookupCCAActivityTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/activity/types/cca`),
  });
export const useLookupCategories = () =>
  useMutation({
    mutationFn: (activityType) =>
      client(`lookups/activity/categories/${activityType}`),
  });
export const useLookupSubCategories = () =>
  useMutation({
    mutationFn: (data) =>
      client(
        `lookups/activity/sub/categories/${data.activityType}/${data.category}`,
      ),
  });
export const useLookupAssignmentGroups = () =>
  useMutation({
    mutationFn: (data) =>
      client(`lookups/assignment/groups/${data.region}/${data.activityType}`),
  });
export const useLookupAllAssignmentGroups = () =>
  useMutation({
    mutationFn: () => client(`lookups/assignment/groups`),
  });
export const useLookupServiceAssignmentGroups = () =>
  useMutation({
    mutationFn: () => client(`lookups/assignment/groups/servicecalls`),
  });
export const useLookupCccallsAssignmentGroups = () =>
  useMutation({
    mutationFn: () => client(`lookups/assignment/groups/cccalls`),
  });
export const useLookupPendingReasons = () =>
  useMutation({
    mutationFn: (category) => client(`lookups/pending/reasons/${category}`),
  });
export const useLookupCashCenters = () =>
  useMutation({
    mutationFn: () => client(`lookups/cash/centers`),
  });

export const useLookupAllRoute = () =>
  useMutation({
    mutationFn: () => client(`lookups/all/routes`),
  });

export const useLookupResolutionCodes = () =>
  useMutation({
    mutationFn: () => client(`lookups/resolution/codes`),
  });
export const useLookupResolutionCodesViaCategory = () =>
  useMutation({
    mutationFn: (category) => client(`lookups/resolution/codes/${category}`),
  });
export const useLookupTicketStatuses = () =>
  useMutation({
    mutationFn: () => client(`lookups/ticketstatuses`),
  });
export const useLookupTasksStatuses = () =>
  useMutation({
    mutationFn: () => client(`lookups/tasks/statuses`),
  });
export const useLookupGetEmployees = () =>
  useMutation({
    mutationFn: () => client(`lookups/employees`),
  });
export const useLookupGetEmployeeDetail = () =>
  useMutation({
    mutationFn: (id) => client(`lookups/employees/${id}`),
  });
export const useLookupGetSecurityTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/tgsi/securitytypes`),
  });
export const useLookupGetContracts = () =>
  useMutation({
    mutationFn: () => client(`lookups/tgsi/contracts`),
  });
export const useLookupGetSites = () =>
  useMutation({
    mutationFn: (contractId) =>
      client(`lookups/tgsi/contracts/sites/${contractId}`),
  });
export const useLookupGetRegion = () =>
  useMutation({
    mutationFn: (countryCode) => client(`lookups/regions/${countryCode}`),
  });

export const useLookupGetAllVans = () =>
  useMutation({
    mutationFn: () => client(`lookups/all/vans`),
  });
export const useLookupOffices = () =>
  useMutation({
    mutationFn: (cashCenterId) =>
      client(`lookups/cash/center/offices/${cashCenterId}`),
  });
export const useLookupBusinessUnit = () =>
  useMutation({
    mutationFn: () => client(`lookups/business/units`),
  });
